module.exports = __webpack_public_path__ + "img/user.6ad66ff5.svg";